let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lSS91")).then(() => parcelRequire('7xEnC'));